import { useQuery } from '@tanstack/react-query';
import { cpFetch } from '@/lib/cpClient';

export type CustodianIntrospectionEndpoint =
  | 'knowledge-base'
  | 'sops'
  | 'overview';

export function useCustodianIntrospection(endpoint: CustodianIntrospectionEndpoint) {
  return useQuery({
    queryKey: ['custodian', 'introspection', endpoint],
    queryFn: () =>
      cpFetch<any>(`/api/agent-custodian/introspection/${endpoint}`),
    staleTime: 300_000,
    retry: 1,
  });
}
